(ns ycweb.weber.common
  (:require
    [rum.core :as rum]
    [ycweb.util.core :as u]
    [util.string :as str]))

(defn idfy [name]
  (str/replace (str/lower-case (or name "")) #"[^a-z0-9]" "-"))

(rum/defc loadimg []
  [:img {:src "/amanda/images/loaders/loader6.gif"}])

(rum/defc clear []
  [:br.clear])

(rum/defc a [text url & {:keys [class name attrs confirm]}]
  [:a
   (u/maybe assoc
     (or attrs {})
     :href url
     :class class
     :name name
     :confirm confirm)
   text])

(defn action-a [text url & {:keys [class name attrs confirm] :as opts}]
  (->
    (apply a text url (mapcat identity opts))
    (update-in [1 :class] #(if % (str % " " "ajax-action") "ajax-action"))))

(defn expand-link [id name]
  (a name "" :class "expander" :attrs {:data-expandid id}))

(rum/defc expand-div [id content]
  (into
    [:div {:id id :class [:expand-div]}]
    [content]))